import Compras from "./Compras";
export default Compras;